export default __webpack_public_path__ + "static/media/analisis-1.ee1149a5.PNG";